import {
  PTL_TASK_LIST,
} from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  response: null,
  loading: false
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case PTL_TASK_LIST[REQUEST]:
      return { ...state, response: null, loading: true };
    case PTL_TASK_LIST[SUCCESS]:
      return { ...state, response: action.response, loading: false };
    case PTL_TASK_LIST[FAILURE]:
      return { ...state, response: null, loading: false };
    default:
      return state;
  }
}

export const ptlTaskListReducer = (state) => state.ptlTaskList.response;